(function () {
  'use strict';

  var STAGGER = 90;
  var MAX_STAGGER = 5;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function collect() {
    var main = document.getElementById('page-content');
    if (!main) return [];

    var groups = [];

    // Titoli di sezione: entrano per primi, con filetto che si estende sotto.
    main.querySelectorAll('.section-heading').forEach(function (node) {
      groups.push([node]);
    });

    // Blocchi editoriali testo/immagine.
    main.querySelectorAll('.image-with-text__text, .feature-header, .newsletter-form, .gallery__row').forEach(
      function (node) {
        groups.push([node]);
      }
    );

    // Griglie di collezioni/prodotti: stagger sui figli.
    main.querySelectorAll('.product-list').forEach(function (list) {
      // I caroselli sono gestiti da Swiper: si anima il contenitore, non le slide.
      if (list.classList.contains('swiper-container')) {
        groups.push([list]);
        return;
      }
      var items = list.querySelectorAll(':scope > .product-block, :scope > .collection-block');
      if (items.length) groups.push(Array.prototype.slice.call(items));
    });

    return groups;
  }

  function decorate(groups) {
    var all = [];

    groups.forEach(function (items) {
      items.forEach(function (node, i) {
        if (!node || node.classList.contains('fo-rise')) return;
        // Il tema ha già il suo sistema cc-animate: non si raddoppia l'effetto.
        if (node.hasAttribute('data-cc-animate')) return;
        if (node.closest('[data-fo-immersive]')) return;

        node.classList.add('fo-rise');
        var delay = Math.min(i, MAX_STAGGER) * STAGGER;
        if (delay) node.style.setProperty('--fo-rise-delay', delay + 'ms');
        all.push(node);
      });
    });

    return all;
  }

  function addRules() {
    var main = document.getElementById('page-content');
    if (!main) return;
    main.querySelectorAll('.section-heading').forEach(function (node) {
      if (node.querySelector('.fo-rule')) return;
      var rule = document.createElement('span');
      rule.className = 'fo-rule';
      rule.setAttribute('aria-hidden', 'true');
      node.appendChild(rule);
    });
  }

  /* Le carte oltre la seconda di una striscia orizzontale non entrano mai nel
     viewport verticale: l'osservatore non scattava e chi trascinava di lato
     trovava schede vuote. Chi vive in una striscia viene innescato dalla
     striscia stessa. */
  function triggerFor(node) {
    var track = node.parentElement;
    if (!track) return node;
    if (track.scrollWidth > track.clientWidth + 8) return track;
    return node;
  }

  function observe(nodes) {
    /* Su schermo verticale un solo blocco riempie quasi tutta l'altezza: con il
       margine negativo del desktop l'ingresso partiva quando il blocco era già
       a metà schermo, quindi si scorreva dentro una fascia vuota. Sul telefono
       l'innesco anticipa il bordo inferiore. */
    var phone = window.matchMedia('(max-width: 767px)').matches;
    var triggers = [];
    var targets = [];

    nodes.forEach(function (node) {
      var trigger = triggerFor(node);
      var i = triggers.indexOf(trigger);
      if (i === -1) {
        triggers.push(trigger);
        targets.push([node]);
      } else {
        targets[i].push(node);
      }
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var i = triggers.indexOf(entry.target);
          if (i > -1) {
            targets[i].forEach(function (node) {
              node.classList.add('is-in');
            });
          }
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      phone
        ? { rootMargin: '0px 0px 12% 0px', threshold: 0 }
        : { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    triggers.forEach(function (trigger) {
      io.observe(trigger);
    });
  }

  /* Il popup della newsletter parte a tempo. Se scatta mentre l'esperienza
     immersiva tiene la pagina resta invisibile ma congela lo scorrimento: la
     pagina muore senza che si veda nulla. Qui il popup viene messo in attesa e
     riproposto a esperienza conclusa; in più, se il blocco resta appeso senza
     un popup a schermo, lo si toglie. */
  function popupGate() {
    var body = document.body;
    var pop = document.querySelector('.section-popup.cc-popup');
    var pending = false;
    var timer = null;

    function busy() {
      if (body.classList.contains('fo-immersive-pinning')) return true;
      return !!document.querySelector('.fo-immersive') && !body.classList.contains('fo-immersive-done');
    }

    function unfreeze() {
      body.classList.remove('cc-popup-no-scroll');
      body.classList.remove('cc-popup-no-scroll-pad-right');
      body.style.paddingRight = '';
    }

    function check() {
      if (pop) {
        if (pop.classList.contains('cc-popup--visible')) {
          if (busy()) {
            pending = true;
            pop.classList.remove('cc-popup--visible');
          }
        } else if (pending && !busy() && !timer) {
          timer = window.setTimeout(function () {
            timer = null;
            pending = false;
                  pop.classList.add('cc-popup--visible');
                  try {
                    window.sessionStorage.setItem('fo_popup_seen', String(Date.now()));
                  } catch (e) {}
                }, 1200);
        }
      }

      if (body.classList.contains('cc-popup-no-scroll') && !document.querySelector('.cc-popup--visible')) {
        unfreeze();
      }
    }

    var mo = new MutationObserver(check);
    mo.observe(body, { attributes: true, attributeFilter: ['class'] });
    if (pop) mo.observe(pop, { attributes: true, attributeFilter: ['class'] });
    check();
  }

  ready(function () {
    popupGate();

    if (!('IntersectionObserver' in window)) return;
    if (!document.body.classList.contains('template-index')) return;

    addRules();
    var nodes = decorate(collect());
    if (nodes.length) observe(nodes);

    // L'immagine editoriale grande guadagna un ken burns lentissimo.
    var editorial = document.querySelector('#page-content .image-with-text__image__inner');
    if (editorial) editorial.classList.add('fo-kenburns');
  });
})();
